<div class="drop-zone-wrapper" #dropZoneWrapper>
  <div
    *ngIf="!uploading"
    class="custom-drop-zone"
    [style]="{'height': '250px'}"
    [dropzone]="dropZoneConfig"
    (addedFile)="filesAdded($event)"
  >
    <div class="upload-icon-wrapper">
      <mat-icon class="dark" matSuffix>{{'cloud_upload'}}</mat-icon>
    </div>
  </div>

  <app-uploading-spinner *ngIf="uploading"></app-uploading-spinner>

</div>

